import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { LegalRolandStepParams } from './types'
import { employmentSchema } from './types'

export const employmentStatus = (params: LegalRolandStepParams) => {
  const schema = employmentSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.legal_roland.employment_status.title',
        },
      },
      {
        type: 'choice',
        options:
          schema.shape.products.shape.mga_legal_roland_de.shape.configuration_parameters.shape.employment_status.options.map(
            (option) => ({
              value: option,
              label: {
                type: 'translatableText',
                translationKey: `sharedFlows_legal:steps.legal_roland.employment_status.options.${option}`,
              },
            })
          ),
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('employment_status'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'insured_parties',
    subFlow: SubFlow.LegalRoland,
  } as const satisfies AnyStepConfiguration
}
